import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { LangService } from '../../core/lang.service';
import { LoginGuardService } from '../../api/login-guard.service';
import { WhitelabelService } from '../../domain/whitelabel.service';
import { BreadcrumbsService } from '../../core/breadcrumbs.service';
import { getLearnMoreLinks, LEARN_MORE_DIR } from '../../ui-landing/data/learnmore';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'learn-more-panel',
  templateUrl: './learn-more-panel.component.html',
  styleUrls: ['./learn-more-panel.component.scss']
})
export class LearnMorePanelComponent implements OnInit {

  @Input() highlightedTitle:string = "";
  directoryPrefix: string;
  public isMobileLinksCollapsed = true;
  public activeTopic;
  public activeSubTopic;
  private dir = LEARN_MORE_DIR;
  private baseRoute = '/';
  public breadcrumb = [];
  private routeSub: Subscription;

  constructor(
    public lang: LangService,
    private route: ActivatedRoute,
    private breadcrumbsService: BreadcrumbsService
  ) { }
  
  ngOnInit() {
    this.directoryPrefix = this.breadcrumbsService.learnMoreSection.APPLICANT;
    this.baseRoute = this.breadcrumbsService.APPLICANT_LEARNMORE().route + '/';
    this.routeSub = this.route.params.subscribe(e => this.onRouteChange(e));
  }

  ngOnDestroy() {
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
    this.getTopics().forEach(topic => {
      topic.toggled = false;
    })
  }

  ngOnChanges(changes: SimpleChanges){
    if(changes.highlightedTitle){
      this.highlightedTitle = changes.highlightedTitle.currentValue;
    }
  }

  onRouteChange(routeParams: any) {
    const topicPath: string = routeParams['topicPath'];
    this.breadcrumb = []
    console.log("topicPath")
    // select the active path
    this.activeTopic = null;
    this.activeSubTopic = null;
    if (topicPath) {
      const topicPathArr = topicPath.split(':');
      const topicId = topicPathArr[0];
      const subtopicId = topicPathArr[1];
      this.getTopics().forEach(topic => {
        if (topic.id === topicId) {
          this.activeTopic = topic;
          // auto toggle the selected topic
          topic.toggled = true;
          if (subtopicId && topic.sub) {
            topic.sub.forEach(subtopic => {
              if (subtopic.id === subtopicId) {
                this.activeSubTopic = subtopic;
              }
            });
          }
        }else{
          topic.toggled = false;
        }
      });

      // scroll up
      window.scrollTo(0, 0);
      this.isMobileLinksCollapsed = true;

      // breadcrumbs
      if (this.activeTopic) {
        this.breadcrumb.push({
          caption: this.getTitleTranlsated(this.activeTopic.path),
          route: this.baseRoute + this.activeTopic.path,
        });
      }
      if (this.activeSubTopic) {
        this.breadcrumb.push({
          caption: this.getTitleTranlsated(this.activeSubTopic.path),
          route: this.baseRoute + this.activeSubTopic.path,
        });
      }
    }
  }

  toggleMobileLinksCollapse() {
    this.isMobileLinksCollapsed = !this.isMobileLinksCollapsed;
  }

  getTitleTranlsated(route: string) {
    const slug = [
      'lm_title',
      this.directoryPrefix,
      route
    ].join(':');
    return this.lang.tra(slug);
  }

  isTopicSelected(topic) {
    return topic.id === this.activeTopic?.id;
  }
  isSubTopicSelected(subTopic) {
    return subTopic.id === this.activeSubTopic?.id;
  }
  isAnySubTopicSelected(topic) {
    return topic?.sub?.some((s) => s.id == this.activeSubTopic?.id) === true;
  }
  getNodePath(node) {
    return this.baseRoute + node.path;
  }

  getTopics(): any[] {
    let rootNode = this.dir[0];
    this.dir.forEach(node => {
      if (node.id === this.directoryPrefix) {
        rootNode = node;
      }
    });

    return rootNode.sub;
  }

  handleToggleTopic(topic){
    topic.toggled = !topic.toggled;
  }

}
